import Vue from "vue";
import Router from "vue-router";
import AuthGuard from "./auth-guard";
import AuthGuardCognito from "./auth-guard-cognito";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      beforeEnter: AuthGuardCognito,
      path: "/",
      name: "dasboard",
      component: () =>
        import(/* webpackChunkName: "dashboard" */ "../views/Dashboard.vue"),
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login" */ "../views/Login.vue"),
    },
    {
      beforeEnter: AuthGuardCognito,
      path: "/stock",
      name: "stock",
      component: () =>
        import(/* webpackChunkName: "stock" */ "../views/Stock.vue"),
    },
    {
      beforeEnter: AuthGuardCognito,
      path: "/promotions/:type",
      name: "promotions",
      component: () =>
        import(/* webpackChunkName: "promotions" */ "../views/Promotions.vue"),
    },
    {
      beforeEnter: AuthGuardCognito,
      path: "/magazines",
      name: "magazines",
      component: () =>
        import(/* webpackChunkName: "magazines" */ "../views/Magazines.vue"),
    },
    {
      beforeEnter: AuthGuardCognito,
      path: "/industrialMagazines",
      name: "industrialMagazines",
      component: () =>
        import(
          /* webpackChunkName: "industrialMagazines" */ "../views/IndustrialMagazines.vue"
        ),
    },
    {
      beforeEnter: AuthGuardCognito,
      path: "/locations",
      name: "locations",
      component: () =>
        import(/* webpackChunkName: "locations" */ "../views/Locations.vue"),
    },
  ],
});
